import React from 'react';
import { useInViewOnce } from '../../hooks/useInViewOnce';
interface StaggerTitleProps {
  text: string;
  className?: string;
  as?: 'h1' | 'h2' | 'h3';
  delay?: number;
}

/**
 * Title that animates in letter by letter the first time it enters the
 * viewport. Each character is a span with a CSS transition-delay — no
 * per-frame JavaScript involved.
 */
export function StaggerTitle({
  text,
  className = '',
  as: Tag = 'h2',
  delay = 0
}: StaggerTitleProps) {
  const {
    ref,
    inView
  } = useInViewOnce<HTMLHeadingElement>(0.25);
  const words = text.split(' ');
  let index = -1;
  return <Tag ref={ref} className={`${inView ? 'is-visible' : ''} ${className}`} aria-label={text} data-id="element-145" data-mp="cxyi9mgdm1xe">
      {words.map((word, wordIdx) => <span key={`${word}-${wordIdx}`} className="stagger-word" data-id="element-146" data-mp="81ghsys2wpqv" data-mpi={wordIdx}>
          {Array.from(word).map((char, charIdx) => {
        index += 1;
        return <span key={`${char}-${charIdx}`} aria-hidden="true" className="stagger-char" style={{
          transitionDelay: `${delay + index * 0.022}s`
        }} data-id="element-147" data-mp="22epraqkmkb94" data-mpi={charIdx}>
                {char}
              </span>;
      })}
          {wordIdx < words.length - 1 ? <span aria-hidden="true" data-id="element-148" data-mp="3s6v69w853rwn">&nbsp;</span> : null}
        </span>)}
    </Tag>;
}